import { withDistributorContext } from '@mews-distributor/common';

import { inject } from './inject';
import { ViewHeading as BaseViewHeading, ViewHeadingProps } from './ViewHeading';

export const ViewHeading = withDistributorContext<ViewHeadingProps>(inject(BaseViewHeading));
